const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const fetchOutlets = async () => {
  const response = await fetch(`${BASE_URL}/v5/rider/hubs`);
  if (!response.ok) {
    throw new Error('Failed to fetch outlets');
  }
  return response.json();
};

export const sendTruckAlert = async (hubCode, status) => {
  const response = await fetch(`${BASE_URL}/v1/admin/truck-alerts`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      City: 'Kuala_Lumpur',
    },
    body: JSON.stringify({ hub_code: hubCode, status }),
  });
  if (!response.ok) {
    throw new Error('Failed to send truck alert');
  }
};

export const submitDeliveryReport = async (payload) => {
  const response = await fetch('/api/submit-delivery-report', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });

  const result = await response.json().catch(() => ({}));
  if (!response.ok || !result.ok) {
    throw new Error(result.error || 'Failed to submit delivery report');
  }
  return result;
};
